export default "__VITE_ASSET__c5562483__"